<template>
  <Instance
    instance="operationalArea"
    instance-name="Operational Area"
    :create="(d) => operationalArea.create(d)"
    :delete="(d) => operationalArea.remove(d)"
    :update="(d) => operationalArea.update(d)"
    :get="(d) => operationalArea.get(d)"
    :upsert="upsert"
    :details="details"
    :columns="columns"
    :header="false"
    headerBg="#ffffff"
  />
</template>

<script>
import { BIconPencil, BIconCardText } from 'bootstrap-vue';

import Instance from '../../../CRUD/instance';
import { SHIFT_TYPES } from '../../../../../../../../constants';
import api from '../../../../api';

export default {
  title: 'Company',
  components: { Instance },
  data() {
    return {
      operationalArea: api.operationalArea,
      upsert: [
        { value: 'name', name: 'Name', required: true },
        { value: 'cid', name: 'ID', required: true },
        { value: 'address', name: 'Address' },
        { value: 'phone', name: 'Phone' },
        { value: 'contactPerson', name: 'Contact Person' },
        { value: 'corporation', name: 'Corporation', type: 'select', data: [], required: true },
        { value: 'company', name: 'Company', type: 'select', data: [], required: true },
        {
          value: 'type',
          name: 'Type',
          type: 'select',
          data: Object.values(SHIFT_TYPES).map((v) => ({ value: v, text: this.$translate(v) })),
          required: true,
        },
      ],
      details: [
        {
          header: 'DETAILS',
          content: [
            { value: 'name', name: 'Name' },
            { value: 'cid', name: 'ID' },
            { value: 'address', name: 'Address' },
            { value: 'phone', name: 'Phone', phoneValidation: true },
            { value: 'contactPerson', name: 'Contact Person' },
            { value: 'type', name: 'Type' },
            { value: 'corporation', name: 'Corporation', render: (o) => (o.name ? `${o.name} (${o.address})` : '-') },
            { value: 'company', name: 'Company', render: (o) => (o.name ? `${o.name} (${o.address})` : '-') },
          ],
        },
      ],
    };
  },
  async created() {
    const corporation = await api.corporation.get();
    const company = await api.company.get();
    this.upsert.forEach((i) => {
      if (i.value === 'corporation') {
        i.data = corporation.map((c) => ({ value: c.id, text: `${c.name} (${c.address})` }));
      }
      if (i.value === 'company') {
        i.data = company.map((c) => ({ value: c.id, text: `${c.name} (${c.address})` }));
      }
    });
  },
  methods: {
    columns({ editInstance, instanceDetails }) {
      return [
        {
          field: 'check',
          key: '1',
          type: 'checkbox',
          title: '',
          width: 50,
          align: 'center',
        },
        {
          field: 'cid',
          title: this.$translate('ID'),
          key: '2',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'name',
          title: this.$translate('Name'),
          key: '3',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'address',
          title: this.$translate('Address'),
          key: '4',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'type',
          title: this.$translate('Type'),
          key: '5',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return this.$translate(row.type);
          },
        },
        {
          field: 'corporation',
          title: this.$translate('Corporation'),
          key: '6',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return row.corporation ? `${row.corporation.name} (${row.corporation.address})` : '-';
          },
        },
        {
          field: 'company',
          title: this.$translate('Company'),
          key: '7',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return row.company ? `${row.company.name} (${row.company.address})` : '-';
          },
        },
        {
          field: 'actions',
          title: '',
          key: '10',
          renderBodyCell: ({ row }) => {
            return (
              <div class="action-block">
                <div class="details-action" on-click={() => editInstance(row)}>
                  <BIconPencil />
                </div>
                <div class="details-action" on-click={() => instanceDetails(row)}>
                  <BIconCardText />
                </div>
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>
